$(document).ready(function(){
  $('.featured-products__slider').slick({
    infinite: true,
    dots: true,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: '<div class="arrow-right"><img src="//celestialseasonings.com/cdn/shop/t/60/assets/circle-chevron-right-solid.png?v=60557831289425944161790123955" alt="Next"></div>',
    prevArrow: '<div class="arrow-left"><img src="//celestialseasonings.com/cdn/shop/t/60/assets/circle-chevron-left-solid.png?v=56651414327485979271790123955" alt="Previous"></div>'
  });

  $(".featured-products__thumbnail").click(function(){
    $(".featured-products__thumbnail").removeClass("active");
    $(this).addClass("active");
    var i = $(this).data("index");
    var color = $(this).data("color");
    var section = $(this).data("section");
    $('.featured-products__slider').slick('slickGoTo', i);
    $('#section-'+section).css('background', color);
  });

  $('.featured-products__slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $(".featured-products__thumbnail").removeClass("active");
        $(".featured-products__thumbnail[data-index='"+nextSlide+"']").addClass("active");
        var color = $(".featured-products__thumbnail[data-index='"+nextSlide+"']").data("color");
        var section = $(".featured-products__thumbnail[data-index='"+nextSlide+"']").data("section");
        $('#section-'+section).css('background', color);

    $(".featured-products__slide-sticker .sticker").hide();
    $(".featured-products__slide-sticker .sticker[data-index='"+nextSlide+"']").show();
  });

  $(".pronunciation .play-audio").click(function(){
    $(this).parent().find("#sahale-pronunciation-audio")[0].play();
  });

  $(".richtext-section .rt-pronunciation .play-audio").click(function(){
    $(this).parent().find("#richtext-audio")[0].play();
  });
});